import en from './en'
import tw from './tw'
import cn from './cn'

export default {
  en,
  tw,
  cn
}



// WEBPACK FOOTER //
// ./src/locales/index.js